<div class="description">
  {{ description | translate }}
</div>

<automata-crm-email-activity-selector></automata-crm-email-activity-selector>
